import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';
import {Pagination} from 'src/app/domain/search/Pagination';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {SharedWsService} from 'src/app/modules/services/Common/shared-ws.service';
import {NewsService} from 'src/app/modules/services/news/news.service';

import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';

@Component({
    selector: 'app-news-card',
    templateUrl: './news-card.component.html',
    styleUrls: ['./news-card.component.css'],
    encapsulation: ViewEncapsulation.None,

})
export class NewsCardComponent implements OnInit {
    retrievedImage: any;
    base64Data: any;
    public image: any;
    public id = null;
    public item: any;
    public searchObject = new SearchObject();
    public pagination: Pagination = new Pagination();
    public fileitems: any[];
    public criteriaSearch: CriteriaSearch = new CriteriaSearch('fileClCd', '06', '=');
    public current_lang = this.translate.getDefaultLang();
    public dataSearch: Array<CriteriaSearch> = [];
    criteriaSearch2: CriteriaSearch;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private newsService: NewsService,
        private translate: AppTranslateService,
        private translateS: TranslateService,
        private sharedWsService: SharedWsService
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;
        });
    }

    ngOnInit(): void {
      this.id=  this.route.snapshot.params.id;
        this.loadcard();
    }

    loadcard() {

        this.newsService.loadcard(this.id)
            .subscribe(response => {
                this.item = response['payload'];
                this.loadfiles(this.item.newsNo);

                this.base64Data = this.item.thumbnail;
                console.log('data:image/png;base64,' + btoa(this.base64Data));
                this.retrievedImage = 'data:image/png;base64,' + btoa(this.base64Data);
            });
    }

    loadfiles(sequenceNumber) {
        this.criteriaSearch2 = new CriteriaSearch('seqno', sequenceNumber, '=');
        this.dataSearch.push(this.criteriaSearch2);
        this.dataSearch.push(this.criteriaSearch);
        this.pagination.limit = 1000;
        this.pagination.offSet = 0;
        this.searchObject.pagination = this.pagination;
        this.searchObject.dataSearch = this.dataSearch;
        this.newsService.loadFiles(this.searchObject)
            .subscribe(response => {
                this.fileitems = response['payload'].data;
            });
    }


    getlabel(x): any {
        if (x == 'A') {
            return 'Lois';
        } else if (x == 'B') {
            return 'Decrets';
        } else if (x == 'C') {
            return 'Arretes';
        } else if (x == 'E') {
            return 'Manuel_utilisations';
        } else {
            return 'Autres';
        }
    }

    getlangue() {
        return this.translate.getDefaultLang() == 'ar';
    }

    downloadFile(noderef: string, name: string, filePath: string) {

        this.sharedWsService.downloadFile(noderef, filePath, name);
    }

}
